import React from "react";

import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

import {
  AddCardIllustration,
  CredentialAddedIllustration,
  OpenWalletIllustration,
  ScanIllustration,
} from "./WalletIllustrations";

const WalletSteps = ({ credentialName, issuerLogoUrl }) => {
  const { t } = useTranslation(["walletOffer"]);

  const steps = [
    {
      key: "open",
      illustration: (
        <OpenWalletIllustration hint={t("walletOffer:hint_tap_plus")} />
      ),
    },
    {
      key: "tap",
      illustration: (
        <AddCardIllustration hint={t("walletOffer:hint_tap_here")} />
      ),
    },
    { key: "scan", illustration: <ScanIllustration /> },
    {
      key: "done",
      illustration: (
        <CredentialAddedIllustration
          credentialName={credentialName}
          logoUrl={issuerLogoUrl}
        />
      ),
    },
  ];

  return (
    <div>
      <h3 className="text-lg font-bold text-cfHeadingText">
        {t("walletOffer:steps_title")}
      </h3>
      <p className="mt-1 text-sm text-gray-500">
        {t("walletOffer:steps_subtitle")}
      </p>

      <ol className="mb-0 mt-[2rem] grid list-none grid-cols-1 gap-x-10 gap-y-10 p-0 sm:grid-cols-2 xl:grid-cols-4">
        {steps.map(({ key, illustration }, index) => (
          <li key={key} className="flex flex-col">
            <div className="flex min-h-[4.75rem] items-start gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-cfPrimary text-sm font-semibold text-cfSecondary shadow-[0_6px_14px_-6px_var(--cf-primary-color)]">
                {index + 1}
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-semibold text-cfHeadingText">
                  {t(`walletOffer:step_${key}_title`)}
                </span>
                <span className="mt-0.5 block text-xs leading-relaxed text-gray-500">
                  {t(`walletOffer:step_${key}_description`)}
                </span>
              </span>
            </div>

            <div className="relative mt-[1rem] flex flex-1 items-start justify-center">
              {illustration}
              {index < steps.length - 1 ? (
                <span
                  aria-hidden="true"
                  className="absolute right-0 top-1/2 h-9 w-9 -translate-y-1/2 translate-x-[calc(50%+1.25rem)] items-center justify-center rounded-full bg-white text-cfPrimary shadow-[0_4px_12px_-4px_rgba(16,24,40,0.25)] ring-1 ring-gray-200 [display:none] xl:flex"
                >
                  <ChevronRight className="h-4 w-4" strokeWidth={2.5} />
                </span>
              ) : null}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default WalletSteps;
